import { useEffect, useState } from 'react';

import { LDContext } from 'launchdarkly-js-client-sdk';

import { useKeycloakAuth } from '@tsl-frontend/tsl-keycloak-auth';

export const useLaunchDarklyContext = () => {
    const { user } = useKeycloakAuth();

    const [context, setContext] = useState<LDContext>();

    useEffect(() => {
        if (!user) {
            return;
        }

        setContext({
            kind: 'multi',
            organisation: {
                key: user.memberships[0]?.o_urn,
            },
            user: {
                key: user.id,
                membership: user.memberships[0].m_type,
            },
            app: {
                key: 'curriculum-cms',
            },
        });
    }, [user]);

    return context;
};

export default useLaunchDarklyContext;
